const eticaitems = {

  titulo: "Comité de Ética y Prevención de Conflictos de Interés",
  // 🔹 NUEVO: IMAGEN DE FONDO
  background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/MSCI_002.png",

  // 🔹 ICONOS SUPERIORES
  iconos: [
    {
      id: 1,
      texto: "Pronunciamiento Cero Tolerancia",
      icono: "fas fa-gavel",
      ruta: "/documento/18"
    },
    {
      id: 2,
      texto: "Código de Ética",
      icono: "fas fa-clipboard-check",
      ruta: "/documento/4"
    },
    {
      id: 3,
      texto: "Protocolo Cero",
      icono: "fas fa-shield-alt",
      ruta: "/documento/11"
    },
    {
      id: 4,
      texto: "Código de Conducta",
      icono: "fas fa-list-check",
      ruta: "/documento/3"
    }
  ],

  // 🔹 ACORDEÓN
  secciones: [
    {
      id: 1,
      titulo: "Normatividad",
      items: [
        { texto: "Acuerdo mediante el cual se crea el CEPCI", ruta: "/documento/1" },
        { texto: "Bases de Integración, Organización y Funcionamiento del CEPCI", ruta: "/documento/2" },
        { texto: "Lineamientos Generales Integración, Organización y Funcionamiento de los Comités de Ética", ruta: "/documento/9" },
        { texto: "Código de Ética de la Administración Pública del Estado de Hidalgo 2019", ruta: "/documento/4" },
        { texto: "Código de Conducta Para los Servidores Públicos de la SEBISO", ruta: "/documento/3" },
        { texto: "Protocolo Cero para la Prevención...", ruta: "/documento/11" },
        { texto: "Procedimiento y Protocolo Para la Recepción de Denuncias", ruta: "/documento/10" },
        {
          texto: "Formato de Denuncia",
          ruta: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2023/Form_Den_CEPCI_2023.docx",
          externo: true
        }
      ]
    },

    {
      id: 2,
      titulo: "Programas de Trabajo",
      items: [
        { texto: "Programa Anual de Trabajo 2026", ruta: "/documento/19" },
        { texto: "Programa Anual de Trabajo 2025", ruta: "/documento/17" },
        { texto: "Programa Anual de Trabajo 2024", ruta: "/documento/6" }
      ]
    },

    {
      id: 3,
      titulo: "Informes de Actividades",
      items: [
        { texto: "Informe Anual de Actividades 2025", ruta: "/documento/20" },
        { texto: "Informe Anual de Actividades 2024", ruta: "/documento/16" },
        { texto: "Informe Anual de Actividades 2023", ruta: "/documento/7" }
      ]
    },

    {
      id: 4,
      titulo: "Encuestas",
      items: [
        { texto: "Encuesta Código de Ética 2025", ruta: "/documento/21" },
        { texto: "Encuesta Código de Conducta 2025", ruta: "/documento/22" },
        { texto: "Encuesta CEPCI 2025", ruta: "/documento/23" },
        { texto: "Encuesta Código de Ética 2024", ruta: "/documento/13" },
        { texto: "Encuesta Código de Conducta 2024", ruta: "/documento/14" },
        { texto: "Encuesta CEPCI 2024", ruta: "/documento/15" },
        { texto: "Encuesta Código de Conducta 2023", ruta: "/documento/5" }
      ]
    },

    {
      id: 5,
      titulo: "Directorio",
      items: [
        { texto: "Directorio", ruta: "/documento/8" }
      ]
    }
  ]

};

export default eticaitems;